export default __webpack_public_path__ + "static/media/clock.595c3689.svg";